<!-- -------new html of add account manager------------ -->
<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li><a>Account Manager:</a></li>
    <li class="active"><a>Add Account Manager</a></li>
  </ul>
  <div class="right">
    <!-- <span>{{today}}</span> -->
  </div>
</div>
<div class="Content_outer">
  <div class="content_view">
    <div class="row">
      <div class="col-md-12">
        <div class="newform_outer">
          <div class="filter_div">
            <div class="top">
              <h4>{{showEditUsertxt}}</h4>
            </div>
          </div>
          <div class="both_side add_user">
            <div class="left_side">
              <h4>Profile Picture</h4>
              <div class="inner">
                <div class="upload">
                  <img src="{{_imgUrl}}" alt="User" onerror="this.src='./assets/img-new/default_user.png'">
                  <div class="action_btn">
                    <div class="upload-btn-wrapper" *ngIf="showEditUsertxt === 'Create Account Manager'">
                      <button class="btn default_btn" mat-raised-button>Upload Logo</button>
                      <input type="file" name="myfile" ng2FileSelect [uploader]="uploader"
                        (change)="upload($event.target.files)" />
                    </div>

                    <div class="upload-btn-wrapper" *ngIf="showEditUsertxt === 'Edit Account Manger'">
                      <button class="btn default_btn" mat-raised-button>Replace</button>
                      <input type="file" name="myfile" ng2FileSelect [uploader]="uploader"
                        (change)="upload($event.target.files)" />
                    </div>
                    <button *ngIf="showEditUsertxt === 'Edit Account Manger'" class="btn default_btn" mat-raised-button
                      (click)="removeUserImage()">Remove</button>
                  </div>
                  <div class="support">
                    <h5>Supported formats:<span>jpg, png, gif</span></h5>
                    <h5>Maximum Size:<span>500KB</span></h5>
                  </div>
                </div>
              </div>
            </div>
            <form [formGroup]="uForm" (ngSubmit)="saveUser()" class="form_outer">
              <div class="right_side">
                <h4>Manager Details</h4>
                <div class="row">
                  <div class="col col-md-6">
                    <label>Full Name *</label>
                    <input type="text" class="form-control"  formControlName="full_name" id="full_name">
                    <!-- <control-messages class="err-msg" [control]="uForm.controls.full_name"></control-messages> -->
                  </div>
                  <div class="col col-md-6">
                    <label>Email Address *</label>
                    <input type="email" class="form-control" formControlName="email" id="email">
                    <!-- <control-messages class="err-msg" [control]="uForm.controls.email"></control-messages> -->
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <label>Phone Number *</label>
                    <!-- <international-phone-number   formControlName="phone_number" placeholder="Enter phone number" (ngModelChange)="onChangePhoneNo($event)"
                      [maxlength]="20" [defaultCountry]="''" [required]="true" id="phone_number" name="phone_number"
                      [allowedCountries]="['in', 'ca', 'us']"></international-phone-number> -->
                      <span class="err-msg" [style.color]="msgColor">{{message}}</span>
                  </div>
                </div>
                <!-- <control-messages class="err-msg" [control]="uForm.controls.phone_number"></control-messages> -->
                <hr class="horizontal_line">
                <div class="row">
                  <div class="col col-md-6">
                    <label>Address Line 1 *</label>
                    <input type="text" class="form-control"  formControlName="address_line1" id="address_line1">
                    <!-- <control-messages class="err-msg" [control]="uForm.controls.address_line1"></control-messages> -->
                  </div>
                  <div class="col col-md-6">
                    <label>Address Line 2</label>
                    <input type="text" class="form-control"  formControlName="address_line2" id="address_line2">
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <div class="row">
                      <div class="col col-md-6">
                        <label>Country *</label>
                        <span class="custom_select_outer">
                          <select class="custom_select form-control" formControlName="country_name_"  (change)="onChange($event.target.value)">
                            <option  *ngFor="let countrys of countryNames" [value]="countrys.country">{{countrys.country}}</option>
                          </select>
                          <!-- <control-messages class="err-msg" [control]="uForm.controls.country_name_"></control-messages> -->
                        </span>
                      </div>
                      <div class="col col-md-6">
                        <label>State/Province*</label>
                        <span class="custom_select_outer">
                          <select class="custom_select form-control" formControlName="state_name">
                            <option *ngFor="let state of states" [value]="state">{{state}}</option>
                          </select>
                          <!-- <control-messages class="err-msg" [control]="uForm.controls.state_name"></control-messages> -->
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col col-md-6">
                    <div class="row">
                      <div class="col col-md-6">
                        <label>City *</label>
                        <input type="text" class="form-control" formControlName="city_name" id="city_name">
                        <!-- <control-messages class="err-msg" [control]="uForm.controls.city_name"></control-messages> -->
                      </div>
                      <div class="col col-md-6">
                        <label>Postal Code *</label>
                        <input type="text" class="form-control" formControlName="postcode" id="postcode">
                        <!-- <control-messages class="err-msg" [control]="uForm.controls.postcode"></control-messages> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <div class="row">
                      <div class="col col-md-6">
                        <label>TimeZone *</label>
                        <span class="custom_select_outer">
                          <select class="custom_select form-control" formControlName="timezone">
                            <option *ngFor="let timezone of timeZones" [value]="timezone">  {{timezone}}</option>
                          </select>
                          <!-- <control-messages class="err-msg" [control]="uForm.controls.timezone"></control-messages> -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="horizontal_line">
                <div class="form_actions text-right">
                  <button  *ngIf="!updateDataReq" class="primary_btn" mat-raised-button type="submit"  [disabled]="!uForm.valid">Create Manager</button>
                  <button  *ngIf="updateDataReq" class="primary_btn" mat-raised-button type="submit"  [disabled]="!uForm.valid">Update</button>
                  <button   class="default_btn" mat-raised-button (click)="openListPage()">Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
